import React from "react";
import {Box, Button} from "@mui/material";
import {useTheme} from "../../contexts/theme";
import {AspectRatio} from "../../types/generic";

interface ModeSelectorProps {
    modes: any[];
    onModeSelection(mode: any): void;
    selected: any;
    onFocus?: () => void;
    onBlur?: () => void;
}

const ModeSelector: React.FC<ModeSelectorProps> = ({onBlur, modes, onModeSelection, selected, onFocus}) => {

    const theme = useTheme();

    const commonStyle = {
        color: theme.palette.white,
        fontSize: theme.fontSizes.description,
        fontWeight: theme.fontWeights.value,
        borderRadius: theme.border.radius.sm,
        border: `${theme.border.width.thin} ${theme.border.type.solid} ${theme.palette.white}`,
        padding: `${theme.spacing.xs}`,
        backgroundColor: 'transparent',
        '&:disabled': {
            borderColor: theme.palette.lightGrey,
            color: theme.palette.lightGrey,
        },
    };

    const selectedStyle = {...commonStyle}
    selectedStyle.backgroundColor = theme.palette.orange;
    selectedStyle.border = `${theme.border.width.thin} ${theme.border.type.solid} ${theme.palette.orange}`

    function getStyle(format: AspectRatio){
        if (format.label === selected.label){
            return selectedStyle;
        }
        return commonStyle
    }

    return (
        <Box display="flex" gap={theme.spacing.sm}>
            {modes.map(format => (
                <Button
                    key={format.label}
                    sx = {getStyle(format)}
                    onClick={() => !format.disabled && format.label !== selected.label && onModeSelection(format)}
                    disabled={format.disabled}
                    onFocus={onFocus ? () => onFocus() : () => {}}
                >
                    {format.label}
                </Button>
            ))}
        </Box>
    );

}

export default ModeSelector;